<div class="row row--builder">
    <div class="col-sm-12"><h4 class="c-title--subsection text-uppercase">SPEAKERS TO DISPLAY</h4></div>
</div>
<div class="row row--builder sessions-to-display-drawer--dropdown-buttons">
    <div class="sessions-to-display-drawer--filters">
        <div class="c-form-group">
            <div class="input-group">
                <input
                    id="speakerSearch"
                    cclFormInput
                    type="text"
                    [(ngModel)]="searchConfig.label"
                    class="c-form-group__input form-control"
                    placeholder="Search for Speakers..."
                    title="Search for Speakers"
                />

                <div class="input-group-append" (cclClick)="fetchSpeakers()">
                    <span class="c-color-picker input-group-text"><i class="fa fa-search" aria-labelledby="speakerSearch"></i></span>
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="sessions-to-display-drawer--filters">
        <div class="c-form-group">
            <div class="input-group">
                <input
                    id="organizationSearch"
                    cclFormInput
                    type="text"
                    [(ngModel)]="searchConfig.organization"
                    class="c-form-group__input form-control"
                    placeholder="Search for Organization..."
                    title="Search for Organization"
                />

                <div class="input-group-append" (cclClick)="fetchSpeakers()">
                    <span class="c-color-picker input-group-text"><i class="fa fa-search" aria-labelledby="organizationSearch"></i></span>
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <ng-container *ngFor="let item of selectedFilters">
        <div class="col-sm-2" *ngIf="item.item_id == 1">
            <div class="c-form-group">
                <ccl-multi-select-dropdown
                    [placeholder]="'Speaker Type: '"
                    [data]="this.sharedService.speakerTypes"
                    [(ngModel)]="searchConfig.speakerTypeIds"
                    [settings]="speakerTypeIdsDropdownSettings"
                ></ccl-multi-select-dropdown>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="showClearButton()" class="sessions-to-display-drawer--buttons">
        <ccl-basic-button (clickEvent)="clearAllFilter()" [className]="'c-btn--secondary c-btn--sm'"
            >Clear</ccl-basic-button
        >
    </div>
    <div class="sessions-to-display-drawer--buttons">
        <ccl-basic-button (clickEvent)="fetchSpeakers()" [className]="'c-btn--sm'">Search</ccl-basic-button>
    </div>
</div>

<div class="session-list sessions-to-display-drawer--list">
    <ccl-list
        [list]="speakers"
        [columns]="columns"
        [hideFilters]="true"
        [compact]="true"
        [hasSelectableColumns]="true"
        selectionProperty="id"
        (selectionChangeEvent)="selectSessions($event)"
        (filterChangeEvent)="loadFilteredSessions($event)"
        [(selectionDictionary)]="listSelection"
    >
        <span *ngIf="noSpeakers">No Speaker(s) found matching search criteria(s).</span>
    </ccl-list>
</div>
